import { isEmpty } from "lodash";
import React, { memo, useCallback, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import Flx from "../../../layout/Flx";
import ExistingLoanTag from "./ExistingLoanTag";
import { loanDrilldownSet } from "../../../../redux/actions/loanDrilldownActions";
import { loanPipelineClear } from "../../../../redux/actions/loanPipelineActions";

const LoanTagsRenderer = memo(
  ({ sx, tags, onDeleteSuccess, allowDelete = false }) => {
    const loanDrilldown = useSelector((state) => state.loanDrilldown);
    const dispatch = useDispatch();
    const handleOnDeleteSuccess = useCallback(
      (data) => {
        dispatch(loanDrilldownSet(data));
        dispatch(loanPipelineClear());
      },
      [onDeleteSuccess]
    );
    const tagsList = useMemo(
      () => tags || loanDrilldown?.tags || [],
      [loanDrilldown?.tags, tags]
    );

    if (isEmpty(tagsList)) {
      return null;
    }
    return (
      <Flx wrap ac gap={0.5} sx={sx}>
        {tagsList.map((tag) => (
          <ExistingLoanTag
            allowDelete={allowDelete}
            onDeleteSuccess={handleOnDeleteSuccess}
            key={tag}
          >
            {tag}
          </ExistingLoanTag>
        ))}
      </Flx>
    );
  }
);

export default LoanTagsRenderer;
